/** @jsxImportSource @emotion/react */
'use client';

import type { ReactNode } from 'react';
import { ErrorText } from '../atoms/FormField';

export interface FormErrorProps {
  readonly id?: string;
  readonly children: ReactNode;
  readonly className?: string;
}

/**
 * Standalone field error for non-standard controls (e.g. star rating).
 * Prefer {@link ControlledFormField} for labelled text inputs — it wires this automatically.
 */
export function FormError({ id, children, className }: FormErrorProps) {
  if (!children) return null;

  return (
    <ErrorText id={id} role="alert" className={className}>
      {children}
    </ErrorText>
  );
}
